module.exports = __webpack_public_path__ + "static/media/4.c83b8bf9.JPG";